import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { call } from "redux-saga/effects";
import { BASE_API_PATHS } from "../../../constants/apis.constants";
import { ReducerMethods } from "../../store/reducer.methods";

export const CountriesEffectActions = {
  getCountries: `${Entities.Countries}_getCountries`,
};

const initSchema: InitSchemaReducer = {
  definitions: {},
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.Countries,
  initSchema,
  aliasName: DIContainerKeys.CountriesService,
})
export class CountriesService extends HttpService {
  @loader(Loaders.CountriesLoader)
  @action(DIContainerKeys.CountriesService)
  public *getCountries(): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.CountriesLoader, true);
    const response = yield call(
      this.get,
      {
        url: BASE_API_PATHS.getCountries,
      },
      ReducerMethods.UPDATE
    );
    yield this.setLoaderState(Loaders.CountriesLoader, false);
    if (!response?.mr?.Success) return;
    yield this.setEntityStateById(Entities.Countries, 'all', response?.detail);
  }
}